import {
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';

import { SupportedRegions } from '../vaults/editBackupVaultPanel';

export const AllRegionsSelector = ({
  regionName,
  setRegionName,
  title,
  provider,
}: {
  regionName?: string;
  setRegionName: (regionName: string) => void;
  title: string;
  provider: Provider;
}) => {
  return (
    <FormControl size='small' className='w-full'>
      <FormLabel>
        <Typography variant='subtitle1'>{title}</Typography>
      </FormLabel>
      <Select
        data-testid='region'
        value={regionName || ''}
        onChange={(event) => setRegionName(event.target.value)}
      >
        {SupportedRegions[provider]?.map((region, i) => {
          return (
            <MenuItem value={region} key={i} data-testid={`region-${region}`}>
              {region}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
